import { render, staticRenderFns } from "./SignUpRoleModal.vue?vue&type=template&id=8b4eee7c&scoped=true"
import script from "./SignUpRoleModal.vue?vue&type=script&lang=js"
export * from "./SignUpRoleModal.vue?vue&type=script&lang=js"
import style0 from "./SignUpRoleModal.vue?vue&type=style&index=0&id=8b4eee7c&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8b4eee7c",
  null
  
)

export default component.exports